<template>
  <div>
    <div class="inner-title col">Bank Details</div>
    <div class="my-custom-scrollbar table-responsive">
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col">Sl No</th>
            <th scope="col">Account Category</th>
            <th scope="col">Account Number</th>
            <th scope="col">Payment in favour of</th>
            <th scope="col">Account Type</th>
            <th scope="col">Bank Name</th>
            <th scope="col">IFSC Code</th>
          </tr>
        </thead>
        <tbody class="text-left table-body">
          <tr v-for="(bankAccount,index) in bankDetail.bankAccounts" :key="index">
            <td scope="col">{{index+1}}</td>
            <td scope="col">{{bankAccount.accountCategory}}</td>
            <td scope="col">{{bankAccount.accountNumber}}</td>
            <td scope="col">{{bankAccount.paymentInfavourOf}}</td>
            <td scope="col">{{bankAccount.accountType}}</td>
            <td scope="col">{{bankAccount.bankName}}</td>
            <td scope="col">{{bankAccount.ifscCode}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["bankDetail"]
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  text-align: left;
  padding-bottom: 1%;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky !important;
  color: #fff;
  text-align: left;
}
.table-body {
  font-family: "Source Sans Pro", sans-serif;
}
.my-custom-scrollbar {
  max-height: 300px;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  overflow: auto;
}
.my-custom-scrollbar thead th {
  position: sticky;
  top: 0;
}
</style>